import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CheckIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 11, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 8) / 11}
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.88269 0.235023C9.56964 -0.0784399 9.06131 -0.0782422 8.74784 0.235023L3.64025 5.34282L1.37014 3.07273C1.05668 2.75927 0.54856 2.75927 0.235097 3.07273C-0.0783658 3.38619 -0.0783658 3.89431 0.235097 4.20778L3.07261 7.04529C3.22924 7.20192 3.43463 7.28043 3.64003 7.28043C3.84544 7.28043 4.05102 7.20212 4.20765 7.04529L9.88269 1.37005C10.1962 1.0568 10.1962 0.548466 9.88269 0.235023Z"
        fill="currentColor"
      />
    </svg>
  )
})

CheckIcon.displayName = 'CheckIcon'
